<woa-full-page-layout [hideBackButton]="hideBackButton()" [showBackButtonOnDesktop]="true" [showNavbarLogo]="true"
                      [footerControlOrientation]="'horizontal'"
                      [autoDismissOnBack]="false" (onBack)="back()"
                      [pillarboxedOnDesktop]="recentOrder().placedOrder.status === OrderPlacementStatus.ACCEPTED ? 'double-mobile' : 'mobile'">
    @if (recentOrder().placedOrder.status !== OrderPlacementStatus.ACCEPTED) {
        <div class="acceptance">
            <woa-logo class="acceptance-logo" [type]="'vertical'"></woa-logo>
            @if (recentOrder().placedOrder.status === OrderPlacementStatus.PENDING) {
                <div class="acceptance-pending">
                    @if (pendingPhase() === 1) {
                        <div class="acceptance-pending-phase1">
                            <div class="acceptance-pending-phase1-message"
                                 [innerHTML]="'woa.message.order.placement.pendingPhase1' | translate | html"></div>
                            <woa-spinner class="acceptance-pending-phase1-spinner"></woa-spinner>
                        </div>
                    }
                    @if (pendingPhase() === 2) {
                        <div class="acceptance-pending-phase2">
                            <div class="acceptance-pending-phase2-message"
                                 [innerHTML]="'woa.message.order.placement.pendingPhase2' | translate | html"></div>
                            <svg class="acceptance-pending-phase2-progress" [attr.height]="progressSize"
                                 [attr.width]="progressSize">
                                <!--suppress HtmlUnknownAttribute, CssUnknownProperty -->
                                <circle class="acceptance-pending-phase2-progress-circle"
                                        [attr.stroke-width]="progressStrokeWidth" fill="transparent"
                                        [attr.r]="progressRadius" [attr.cx]="progressSize / 2"
                                        [attr.cy]="progressSize / 2"
                                        [style.strokeDasharray]="progressCircumference + ' ' + progressCircumference"
                                        [style.strokeDashoffset]="progressOffset()"/>
                            </svg>
                        </div>
                    }
                </div>
            }
            @if (recentOrder().placedOrder.status === OrderPlacementStatus.CANCELLED) {
                <div class="acceptance-cancelled">
                    <div class="acceptance-cancelled-message"
                         [innerHTML]="'woa.message.order.placement.cancelled' | translate | html"></div>
                </div>
            }
            @if (recentOrder().placedOrder.status === OrderPlacementStatus.REJECTED) {
                <div class="acceptance-rejected">
                    <div class="acceptance-rejected-message"
                         [innerHTML]="'woa.message.order.placement.rejected' | translate | html"></div>
                </div>
            }
        </div>
    }
    @if (recentOrder().placedOrder.status === OrderPlacementStatus.ACCEPTED && responsiveService.desktop()) {
        <div class="order-details" slot="content-left">
            <woa-order-details-panel [recentOrder]="recentOrder()"
                                     [showFulfilmentDetails]="false"></woa-order-details-panel>
        </div>
    }
    @if (recentOrder().placedOrder.status === OrderPlacementStatus.ACCEPTED) {
        <div class="order-placement" slot="content-right">
            <div class="order-placement-summary">
                @if (showCarousel()) {
                    <woa-promo-carousel class="order-placement-summary-promo-carousel"
                                        [nrVisibleSlides]="1"
                                        [promoteMemberRegistration]="true"
                                        [autoScrollEnabled]="!configurationModel.noAutoScroll()"></woa-promo-carousel>
                } @else {
                    @if (configurationModel.isConsumerActor() && orderingContextModel.headerImage()) {
                        <div class="order-placement-summary-header" woa-element-width>
                            <woa-page-header-image woa-responsive
                                                   class="order-placement-summary-header-store-image"></woa-page-header-image>
                        </div>
                    }
                }
                <woa-icon class="order-placement-summary-icon" name="check-circle"></woa-icon>
                <div class="order-placement-summary-heading">
                    <div class="order-placement-summary-heading-title"
                         [innerHtml]="headingTitle() | translate:{
                         name: firstName(),
                         table: recentOrder().orderInitiation.tableNumber,
                         groupOrderName: recentOrder().orderInitiation.transferTargetName | possessive
                     } | html">
                    </div>
                    @if (headingNotice()) {
                        <woa-content-message class="order-placement-summary-heading-notice"
                                             [level]="MessageLevel.SUCCESS"
                                             [text]="headingNotice()"
                                             [translationParams]="{name: firstName()}"></woa-content-message>
                    }
                </div>
            </div>
            <div class="order-placement-details">
                <woa-order-details-panel [recentOrder]="recentOrder()"
                                         [showFulfilmentDetails]="!recentOrder().orderInitiation.transferTargetId"
                                         [showOrderDetails]="responsiveService.mobile()"
                                         [showLocationDetails]="responsiveService.mobile()"></woa-order-details-panel>
            </div>
            <woa-chewzie-attribution class="order-placement-logo"></woa-chewzie-attribution>
        </div>
    }
    @if (recentOrder().placedOrder.status === OrderPlacementStatus.ACCEPTED && configurationModel.isConsumerActor()) {
        <woa-button woa-page-footer-control [label]="'woa.button.common.done'"
                    (onActivate)="orderModel.completeOrder()"></woa-button>
    }
    @if (recentOrder().placedOrder.status === OrderPlacementStatus.ACCEPTED && configurationModel.isWaiterActor()) {
        <woa-button [connotation]="ButtonConnotation.DISSUASIVE"
                    woa-page-footer-control [label]="'woa.button.order.tableDone'"
                    (onActivate)="orderModel.completeOrder(false)"></woa-button>
    }
    @if (recentOrder().placedOrder.status === OrderPlacementStatus.ACCEPTED && configurationModel.isWaiterActor()) {
        <woa-button woa-page-footer-control [label]="'woa.button.order.tableNotDone'"
                    (onActivate)="orderModel.completeOrder(true)"></woa-button>
    }
    @if (recentOrder().placedOrder.status !== OrderPlacementStatus.PENDING && recentOrder().placedOrder.status !== OrderPlacementStatus.ACCEPTED) {
        <woa-button woa-page-footer-control [label]="'woa.button.order.return'" (onActivate)="back()"></woa-button>
    }
</woa-full-page-layout>
